import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import fr from './fr.json'

export const SUPPORTED_LANGUAGES = ['en', 'fr'] as const
export type Language = (typeof SUPPORTED_LANGUAGES)[number]

const LANG_KEY = 'mac_lang'
const DEFAULT_LANGUAGE: Language = 'en'
const SUPPORTED_LANGUAGE_SET = new Set<string>(SUPPORTED_LANGUAGES)

function isSupportedLanguage(value: string | null): value is Language {
  return value !== null && SUPPORTED_LANGUAGE_SET.has(value)
}

function getInitialLanguage(): Language {
  const storedLanguage = localStorage.getItem(LANG_KEY)
  return isSupportedLanguage(storedLanguage) ? storedLanguage : DEFAULT_LANGUAGE
}

i18n.use(initReactI18next).init({
  supportedLngs: SUPPORTED_LANGUAGES,
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  const nextLanguage = isSupportedLanguage(lng) ? lng : DEFAULT_LANGUAGE
  localStorage.setItem(LANG_KEY, nextLanguage)
  document.documentElement.lang = nextLanguage
})

document.documentElement.lang = getInitialLanguage()

export default i18n
